module.exports = __webpack_public_path__ + "static/media/IMG_8714.ee5b5d02.jpg";